export const canCancelAccount = (statusGroup: string | undefined) => {
  if (!statusGroup) return false
  return (
    statusGroup === "Active" ||
    statusGroup === "Pending" ||
    statusGroup === "Rejected" ||
    statusGroup === "Enrolled"
  )
}
